import { createRouter, createWebHistory } from 'vue-router'


import Login from '../views/Login.vue'
import Start from '../views/Start.vue'
import Dashboard from '../views/Dashboard.vue'
import Lingua from '../views/Lingua.vue'
import Install from '../views/install/Install.vue'


import Incassi from '../views/account/Incassi.vue'
import Invoice from '../views/account/Invoice.vue'
import Costi from '../views/account/Costi.vue'
import Scadenzari from '../views/account/Scadenzari.vue'
import PrimaNota from '../views/account/PrimaNota.vue'
import Statistiche from '../views/account/Statistiche.vue'
import NoteSpese from '../views/account/NoteSpese.vue'


import ConfAccessi from '../views/config/ConfAccessi.vue'
import ConfWebsite from '../views/config/ConfWebsite.vue'
import ConfOwner from '../views/config/ConfOwner.vue'
import ConfEmail from '../views/config/ConfEmail.vue'
import ConfGenerali from '../views/config/ConfGenerali.vue'
import ConfGoogle from '../views/config/ConfGoogle.vue'
import ConfRoles from '../views/config/ConfRoles.vue'
import FileManager from '../components/FileManager.vue'
import ConfFooter from '../views/config/ConfFooter.vue'
import Configurazione from '../views/config/Configurazione.vue'


import ConfNavs from '../views/config/ConfNavs.vue'
import ConfSliders from '../views/config/ConfSliders.vue'
import ConfTravelNotifiche from '../views/config/ConfTravelNotifiche.vue'
import Logs from '../views/logs/Logs.vue'


import Contatti from '../views/utenti/Contatti.vue'
import UtentiCms from '../views/utenti/UtentiCms.vue'
import Fornitori from '../views/utenti/Fornitori.vue'
import Agenzie from '../views/utenti/Agenzie.vue'
import UtentiClienti from '../views/utenti/UtentiClienti.vue'


import Accessi from '../components/common/Accessi.vue'
import Errori from '../components/common/Errori.vue'
import GeoStati from '../components/common/GeoStati.vue'
import GeoRegioni from '../components/common/GeoRegioni.vue'
import GeoProvince from '../components/common/GeoProvince.vue'
import GeoComuni from '../components/common/GeoComuni.vue'
import GeoAree from '../components/common/GeoAree.vue'
import GeoContenutoLang from '../components/common/GeoContenutoLang.vue'
import GeoAeroporti from '../components/common/GeoAeroporti.vue'


import Chat from '../views/moduli/Chat.vue'
import Inbox from '../views/moduli/Inbox.vue'
import Notifiche from '../views/moduli/Notifiche.vue'
import Task from '../components/Task.vue'
import Tickets from '../views/moduli/Tickets.vue'
import Emails from '../views/moduli/Emails.vue'


import Progetti from '../views/projects/Progetti.vue'
import Attivita from '../views/projects/Attivita.vue'
import CostiFissi from '../components/ConfVociPreferiteGenerali.vue'


import Categorie from '../views/content/Categorie.vue'
import Manuals from '../views/content/Manuals.vue'
import Guida from '../views/content/Guida.vue'








const routes = [
  {    path: '/Login',                            name: 'Login',                        component: Login  },
  {    path: '/Start',                            name: 'Start',                        component: Start  },
  {    path: '/Dashboard',                        name: 'Dashboard',                    component: Dashboard  },
  {    path: '/Install',                          name: 'Install',                      component: Install  },

  {    path: '/Incassi',                          name: 'Incassi',                      component: Incassi  },
  {    path: '/Invoice',                          name: 'Invoice',                      component: Invoice  },
  {    path: '/Costi',                            name: 'Costi',                        component: Costi  },
  {    path: '/Scadenzari',                       name: 'Scadenzari',                   component: Scadenzari  },
  {    path: '/PrimaNota',                        name: 'PrimaNota',                    component: PrimaNota  },
  {    path: '/Statistiche',                      name: 'Statistiche',                  component: Statistiche  },
  {    path: '/NoteSpese',                        name: 'NoteSpese',                    component: NoteSpese  },

  {    path: '/ConfAccessi',                      name: 'ConfAccessi',                  component: ConfAccessi  },
  {    path: '/ConfWebsite',                      name: 'ConfWebsite',                  component: ConfWebsite  },
  {    path: '/ConfOwner',                        name: 'ConfOwner',                    component: ConfOwner  },
  {    path: '/ConfEmail',                        name: 'ConfEmail',                    component: ConfEmail  },
  {    path: '/ConfNavs',                         name: 'ConfNavs',                     component: ConfNavs  },
  {    path: '/ConfSliders',                      name: 'ConfSliders',                  component: ConfSliders  },
  {    path: '/ConfGoogle',                       name: 'ConfGoogle',                   component: ConfGoogle  },
  {    path: '/ConfRoles',                        name: 'ConfRoles',                    component: ConfRoles  },
  {    path: '/ConfFooter',                       name: 'ConfFooter',                   component: ConfFooter  },
  {    path: '/Configurazione',                   name: 'Configurazione',               component: Configurazione  },
  {    path: '/ConfGenerali',                     name: 'ConfGenerali',                 component: ConfGenerali  },
  {    path: '/ConfTravelNotifiche',              name: 'ConfTravelNotifiche',          component: ConfTravelNotifiche  },
  {    path: '/FileManager',                      name: 'FileManager',                  component: FileManager  },
  {    path: '/Lingua',                           name: 'Lingua',                       component: Lingua  },
  {    path: '/Logs',                             name: 'Logs',                         component: Logs  },
  
  
  {    path: '/Contatti',                         name: 'Contatti',                     component: Contatti  },
  {    path: '/UtentiCms',                        name: 'UtentiCms',                    component: UtentiCms  },
  {    path: '/Fornitori',                        name: 'Fornitori',                    component: Fornitori  },
  {    path: '/Agenzie',                          name: 'Agenzie',                      component: Agenzie  },
  {    path: '/UtentiClienti',                    name: 'UtentiClienti',                component: UtentiClienti  },


  {    path: '/Accessi',                          name: 'Accessi',                      component: Accessi  },
  {    path: '/Errori',                           name: 'Errori',                       component: Errori  },
  {    path: '/GeoStati',                         name: 'GeoStati',                     component: GeoStati  },
  {    path: '/GeoRegioni',                       name: 'GeoRegioni',                   component: GeoRegioni  },
  {    path: '/GeoProvince',                      name: 'GeoProvince',                  component: GeoProvince  },
  {    path: '/GeoComuni',                        name: 'GeoComuni',                    component: GeoComuni  },
  {    path: '/GeoAree',                          name: 'GeoAree',                      component: GeoAree  },
  {    path: '/GeoContenutoLang',                 name: 'GeoContenutoLang',             component: GeoContenutoLang  },
  {    path: '/GeoAeroporti',                     name: 'GeoAeroporti',                 component: GeoAeroporti  },


  {    path: '/Categorie',                        name: 'Categorie',                    component: Categorie  },
  {    path: '/Notifiche',                        name: 'Notifiche',                    component: Notifiche  },
  {    path: '/Task',                             name: 'Task',                         component: Task  },


  {    path: '/Progetti',                         name: 'Progetti',                     component: Progetti  },
  {    path: '/Attivita',                         name: 'Attivita',                     component: Attivita  },
  {    path: '/CostiFissi',                       name: 'CostiFissi',                     component: CostiFissi  },
  
  
  {    path: '/Manuals',                          name: 'Manuals',                      component: Manuals  },
  {    path: '/Guida',                            name: 'Guida',                        component: Guida  },
  {    path: '/Inbox',                            name: 'Inbox',                        component: Inbox  },
  {    path: '/Chat',                             name: 'Chat',                         component: Chat  },
  {    path: '/Tickets',                          name: 'Tickets',                      component: Tickets  },
  {    path: '/Emails',                           name: 'Emails',                       component: Emails  },

  




]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
